module.exports = __webpack_public_path__ + "img/icon-minus-circle.0fe5c689.svg";